function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as i } from "./index.es33.js";
import { clsx as l } from "./index.es105.js";
import e from "./index.es447.js";

var a = function a(_ref) {
  var s = _ref.option;
  return i.jsxs("div", {
    className: l(_defineProperty({}, e.optionValueWrapper, !!s.hint)),
    children: [i.jsxs("div", {
      children: [i.jsx("div", {
        className: e.optionValue,
        children: s.label
      }), typeof s.info == "string" ? i.jsx("div", {
        className: e.optionInfo,
        children: s.info
      }) : s.info]
    }), typeof s.hint == "string" ? i.jsx("div", {
      className: l(e.optionValue, e.hint),
      children: s.hint
    }) : s.hint]
  });
};

export { a as OptionItem };